import {combineReducers} from 'redux'

import * as auth from '@/modules/auth'
import {areasReducer, officesReducer, positionsReducer, jobTitlesReducer, employeesReducer} from '@/modules/employees'
import companyReducer from '@/modules/organizations/redux/CompanyRedux'
import departmentReducer from '@/modules/organizations/redux/DepartmentRedux'
import addressReducer from '@/modules/addresses/redux/AddressRedux'
import usersReducer from '@/modules/users/redux/UserRedux'
import { reducer as rolesReducer } from '@/modules/users/redux/RoleRedux'
import userRolesReducer from '@/modules/users/redux/UserRoleRedux'
import customerReducer from '@/modules/customers/redux/CustomerRedux'
import supplierReducer from '@/modules/suppliers/redux/SupplierRedux'
import orderReducer from '@/modules/orders/redux/OrderRedux'
import { reducer as transactionsReducer } from '@/modules/finance/redux/TransactionRedux'
import { reducer as financeOrdersReducer } from '@/modules/finance/redux/OrderRedux'
import { reducer as transactionTypesReducer } from '@/modules/settings/transaction_type/redux/TransactionTypeRedux'
import { reducer as walletsReducer } from '@/modules/settings/wallet/redux/WalletRedux'
import { documentReducer } from '@/modules/documents/redux'
import { taskReducer, groupReducer, userReducer } from '@/modules/tasks/redux/TaskRedux'
import timekeepingReducer from '@/modules/timekeepings/redux/TimekeepingRedux'
import { reducer as mainReducer } from '@/modules/main/redux/MainRedux'
import globalLoadingReducer from '@/__core/redux/globalLoadingSlice'
import { customersApi } from '@/modules/customers/api/customersApi'
import { rolesApi } from '@/modules/users/api/rolesApi'
import { usersApi } from '@/modules/users/api/usersApi'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  areas: areasReducer,
  offices: officesReducer,
  positions: positionsReducer,
  jobTitles: jobTitlesReducer,
  employees: employeesReducer,
  company: companyReducer,
  department: departmentReducer,
  address: addressReducer,
  users: usersReducer,
  roles: rolesReducer,
  userRoles: userRolesReducer,
  customer: customerReducer,
  supplier: supplierReducer,
  orders: orderReducer,
  financeOrders: financeOrdersReducer,
  transactions: transactionsReducer,
  transactionTypes: transactionTypesReducer,
  wallets: walletsReducer,
  documents: documentReducer,
  tasks: taskReducer,
  groups: groupReducer,
  taskUsers: userReducer,
  timekeepings: timekeepingReducer,
  main: mainReducer,
  globalLoading: globalLoadingReducer,
  [customersApi.reducerPath]: customersApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  // Saga removed to fix circular dependency
  yield []
}
